import React from 'react';
import { Box, Card, Flex, Text } from "@radix-ui/themes";
import { useStore } from '../store/store';
import { useNavigate } from 'react-router-dom';
import avatar from '../assets/avatar4.png';

export const CreateNovel = () => {
    const [state, actions] = useStore();
    const navigate = useNavigate();

    return (
        <div style={{ 
            padding: '15px 20px', 
            margin: '0 auto',
            width: '66%', 
        }}>
            <Text as='div' className='dashboard-header' align={'center'}>Create New Book</Text>

            {state.novels.length === 0 ?
            <Flex className="tutorial-container" style={{ }}>
                <Flex className={"tutorial-text"}>
                    <img src={avatar} alt="Avatar" className="tutorial-avatar" />
                    <div>Choose weather your book will be fiction or non-fiction. They both have a different set-up flow.</div>
                </Flex>
            </Flex> : null}

            <Flex gap="40px" justify="center">
                {/* Fiction Tile */}
                <Box className="novel-card-container">
                    <Card 
                        className='dashboard-novel-card-modern' 
                        onClick={() => navigate('/fiction/new')}
                    >
                        <div className="novel-card-content">
                            <h3 className="novel-card-title">Fiction</h3>
                            <Text style={{ textAlign: 'center', margin: '10px 0', color: 'rgba(255,255,255,0.8)' }}>
                                Novels, Novellas, Fan Fiction, and other creative writing
                            </Text>
                        </div>
                    </Card>
                </Box>

                {/* Non-Fiction Tile */}
                <Box className="novel-card-container">
                    <Card 
                        className='dashboard-novel-card-modern' 
                        onClick={() => navigate('/nonfiction/new')}
                    >
                        <div className="novel-card-content">
                            <h3 className="novel-card-title">Non-Fiction</h3>
                            <Text style={{ textAlign: 'center', margin: '10px 0', color: 'rgba(255,255,255,0.8)' }}>
                                History, Guides, Tutorials and other informative writing
                            </Text>
                        </div>
                    </Card>
                </Box>
            </Flex>
        </div>
    );
}

export default CreateNovel;